import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";

// UI Components
import Select from "react-select";
import { Button, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Badge } from "reactstrap";

import { humanizeGroup } from "../../utils/normalize";

/**
 * The preview modal and associated button handlers
 * @constructor
 */
const SelectUserModal = ({ users, admin_token, current_token, current_user, selectUser }) => {
  // Local Variables
  const [showModal, setShowModal] = useState(false);

  const toggle = () => setShowModal(!showModal);

  const closeBtn = (
    <button className="close" onClick={toggle}>
      &times;
    </button>
  );

  const placeholder =
    admin_token !== current_token
      ? `Currently viewing the dashboard as "${current_user.firstname_vch} ${current_user.lastname_vch}"`
      : "View the dashboard as another user";

  return (
    <Fragment>
      <Select
        isSearchable
        className="react-select-container"
        classNamePrefix="react-select"
        options={users}
        // value={current}
        value={null}
        placeholder={placeholder}
        onChange={selectUser}
        formatOptionLabel={(user, { context }) => {
          return context === "value" ? (
            <span className="w-100">{`${user.firstname_vch} ${user.lastname_vch}`}</span>
          ) : (
            <span className="w-100">
              {`${user.firstname_vch} ${user.lastname_vch}`}
              <Badge className="float-right">{humanizeGroup(user.group_id_bint)}</Badge>
            </span>
          );
        }}
        getOptionLabel={(user) => user.user_id_bint}
        getOptionValue={(user) => user.user_id_bint}
        filterOption={(option, searchText) =>
          option.data.user_id_bint === searchText ||
          option.data.firstname_vch.toLowerCase().includes(searchText.toLowerCase()) ||
          option.data.lastname_vch.toLowerCase().includes(searchText.toLowerCase())
        }
      />

      {/* MODAL */}
      <Modal size="lg" isOpen={showModal} toggle={toggle}>
        <ModalHeader toggle={toggle} close={closeBtn} className="text-uppercase">
          Change user
        </ModalHeader>

        <ModalBody>
          <Row>
            <Col className="text-center">
              <h4>Select a user</h4>
            </Col>
          </Row>

          <Row>
            <h3>TODO</h3>
          </Row>
        </ModalBody>

        <ModalFooter className="d-flex justify-content-between">
          <Button color="primary" outline>
            Cancel
          </Button>

          <Button color="primary">Select</Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

SelectUserModal.propTypes = {
  user: PropTypes.object,
  users: PropTypes.array,
};

export default SelectUserModal;
